<template>
    <div :style="style">
        <Wp_news :datas="list" :auto-play="auto_play"  @clickItem="clickNewsItem"></Wp_news>
    </div>

</template>

<script>
    import Wp_news from "../custom/Wp_news";
    export default {
        name: "Wp_home_news_model",
        components: {Wp_news},
        props:{
            params:{type: Object},
            list:{type: Array},
        },

        data(){
            return{
                // list: [],
                style: "",
                auto_play: 5000,
            }
        },

        created(){
            this.initNewsDatas();
        },

        methods:{

            initNewsDatas(){
                if(this.params){
                    // if(this.params.list){
                    //     this.list = this.params.list;
                    // }
                    if(this.params.style){
                        this.style = this.params.style;
                    }
                    if(this.params.auto_play){
                        this.auto_play = this.params.auto_play;
                    }
                }
            },

            clickNewsItem(item){
                // this.$common.homeModelClickTo(item, this.$router);
                this.$clickHomeModelTo(item);
            },

        }
    }
</script>

<style scoped>

</style>